import { useNavigate } from "react-router-dom";

import { PublicTechnicalDecisionTableItem } from "api/public/technicalDecisions/technicalDecisions.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { techDecisionsColumns } from "./TechDecisions.columns";

interface TechDecisionsTableProps {
  archived: boolean;
  activeTds: PublicTechnicalDecisionTableItem[];
  archivedTds: PublicTechnicalDecisionTableItem[];
  loading: boolean;
}

export default function TechDecisionsTable({
  archived,
  activeTds,
  archivedTds,
  loading,
}: TechDecisionsTableProps) {
  const navigate = useNavigate();

  const title = `${archived ? "Archived" : "Active"} Technical Decisions`;

  return (
    <DefaultDataGrid
      title={title}
      columns={techDecisionsColumns}
      getRowId={(row) => row.td_id}
      rows={archived ? archivedTds : activeTds}
      onRowClick={({ row }) => navigate(`./${row.identifier}`)}
      columnVisibilityModel={{ removed_on: archived }}
      loading={loading}
      disableCellFocus
      clickableRow
      // HACK: - similar issue on Public Labgrams table, and related one on PCL table
      // This is a deprecated property, but without it in place
      // this table will constantly resize under mysterious circumstances
      // that we have not been able to identify yet.
      // It occurs on Eric's laptop at home, and not in the office
      // specifically with the dataset from dev, over 50 rows present,
      // and multiple rows that reflow when the width changes
      // when the parent container is something like the Paper component.
      // We have ruled out browser, and machine, and os as the culprits
      // we have only been able to reproduce on Eric's mac, Sazhelle's Windows
      // and one end user's machine so far.
      // Further investigation may be required to identify the actual issue, but
      // this is a rabbit hole and this solution works for now.
      autoHeight
    />
  );
}
